<template>
   <Dropdown 
      class="fx-dropdown"
      trigger="click"
      @on-click="clickAction($event,params)"
   >
      <a class="btn-action" href="javascript:void(0)">
         <i class="fa fa-chevron-circle-down"></i>
      </a>
      <DropdownMenu slot="list">
         <DropdownItem 
            v-for="(action,i) in actions" 
            :name="action.event"
            :key="i"
         >
            <div class="clearfix" v-if="action.type === 'menu'">
               <i class="fa" :class="action.icon || 'fa-eye'"></i> 
               <div class="menu-text">{{action.title}}</div> 
            </div>

            <span v-if="action.type === 'title'">{{action.title}}</span>
         </DropdownItem>
      </DropdownMenu>
   </Dropdown>
</template>

<script>
export default {
   name: "TableActions",
   components:{
      Dropdown: () => import("../dropdown/dropdown"),
      DropdownItem: () => import("../dropdown/dropdown-item"),
      DropdownMenu: () => import("../dropdown/dropdown-menu"),
   },
   props:{
      actions: {
         type: Array,
         default: function(){
            return []
         }
      },
      params: {
         type: Object,
         default: 0
      },
   },
   methods:{
      clickAction(action,params){
         this.$emit('on-action',{action,row: params})
      },
   },
   mounted(){
      
   },
   
}
</script>